var AlyleServiceConfig = (function () {
    function AlyleServiceConfig() {
    }
    return AlyleServiceConfig;
}());
export { AlyleServiceConfig };
function AlyleServiceConfig_tsickle_Closure_declarations() {
    /** @type {?} */
    AlyleServiceConfig.prototype.primary;
    /** @type {?} */
    AlyleServiceConfig.prototype.accent;
    /** @type {?} */
    AlyleServiceConfig.prototype.other;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui/core/alyle-config-service.js
// module id = 269
// module chunks = 31